export default "__VITE_ASSET__DwjYRVw9__"